import { Injectable } from '@angular/core';
import { Http,Response, Headers,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/catch';
import {Observable} from "rxjs";
import {Tienda} from "../tienda/tienda";
import {AuthenticationService} from "../Login/authentication.service";
import {UrlService} from "./url.service";


@Injectable()
export class TiendaService
{

  private headers = new Headers({'Content-Type':'application/json',
    'Authorization': 'Bearer ' + this.authenticationService.token  });//parametrizamos a json
  private options = new RequestOptions({ headers: this.headers });
  private url = this.URL.getLocal()+'/tienda';//Url que maeja GET ,POST
  private urlEstadistica = this.URL.getLocal()+'/estadistica/ventas/mensual';//Url que maeja GET ,POST
  private urlAsignacion = this.URL.getLocal()+'/tiendausuario';//Url que maeja GET ,POST
  private urlById = this.URL.getLocal()+'/tiendausuario/';//busca un Tienda por cedula
  private urlVentasBytienda = this.URL.getLocal()+'/factura/ventatienda/';//busca un Tienda por cedula
  private urlSeparadosBytienda = this.URL.getLocal()+'/factura/ventaseparados/';//busca un Tienda por cedula
  private urlPut = this.URL.getLocal()+'/tienda/';//la direccion a la cual se conecta


  //Constructor de la clase
  constructor(private URL:UrlService,private http:Http, private authenticationService: AuthenticationService)
  {
    //this.headers.append('Content-Type', 'application/x-www-form-urlencoded');
    //this.headers.append('X-Requested-With', 'XMLHttpRequest');
  }
  //Obtiene una lista de Tiendas
  getTienda():Observable<Tienda[]> {
    let url = `${this.url}`;
    return this.http.get(url,this.options)
      .map(r => r.json())
      .catch(this.handleError)
  }
  getUsuariosByTienda(id: number): Observable<any[]> {
    let url = `${this.urlById}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }
  getVentasByTienda(id: number): Observable<any[]> {
    let url = `${this.urlVentasBytienda}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }
  getSeparadosByTienda(id: number): Observable<any[]> {
    let url = `${this.urlSeparadosBytienda}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }

  getEstadisticaTienda():Observable<Tienda[]> {
    let url = `${this.urlEstadistica}`;
    return this.http.get(url,this.options)
      .map(r => r.json())
      .catch(this.handleError)
  }

  addTienda(Tienda:Tienda) {
    let url = `${this.url}`;
    let iJson = JSON.stringify(Tienda);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }
  asignarUsuario(Datos:Tienda) {
    let url = `${this.urlAsignacion}`;
    let iJson = JSON.stringify(Datos);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }
  putTienda(Tienda : Tienda,id:number){
    let url = `${this.urlPut}${id}`;
    let CJson = JSON.stringify(Tienda);
    return this.http.put(url,CJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);
  }
//Este metodo detecta un error en la llamada a http
  private handleError(error : Response | any) {
    let errMsj : string;
    if(error instanceof Response)
    {
      let body  = error.json() || '';
      let err = body.error || JSON.stringify(body);
      errMsj = `${error.status} - ${error.statusText || ''} ${err}`;
    }
    else
    {
      errMsj = error.message ? error.message : error.Tostring();
    }
    return Observable.throw(errMsj);
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Services/tienda.service.ts